
























































































import { Vue, Component, Ref } from 'vue-property-decorator'
import { obrigatorio } from '@/shareds/regras-de-form'
import { TipoDeOperacao } from '@/models/Recurso'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { montarOperacaoDeRecurso } from '@/shareds/permissoes-shareds'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { TamanhoDaEtiqueta } from '@/models/EtiquetaDePreco'
import SeletorDeGruposEconomicos from "@/components/loja/SeletorDeGruposEconomicos.vue"
import { Inject } from 'inversify-props'
import { type EtiquetaDePrecoServiceAdapter } from '@/usecases';
import DatePicker from '@/components/ui/DatePicker.vue'
import moment from "moment"

@Component({
	components: {
		SeletorDeGruposEconomicos,
		DatePicker,
	},
})

export default class DialogoDeEdicaoCadastroTamanhoDeEtiqueta extends Vue {
	@Ref() form!: HTMLFormElement
	@Ref() campoDeDescricao!: HTMLInputElement

	tamanhoDaEtiqueta: TamanhoDaEtiqueta | null = null
	obrigatorio = obrigatorio
	mostra = false
	criandoNovoTamanho = false
	salvando = false
	
	@Inject('EtiquetaDePrecoServiceAdapter')
	private etiquetaDePrecoService!: EtiquetaDePrecoServiceAdapter

	mostrar(tamanhoDaEtiqueta: TamanhoDaEtiqueta | null, criandoNovoTamanho: boolean ) {
		this.tamanhoDaEtiqueta = JSON.parse(JSON.stringify(tamanhoDaEtiqueta))
		this.mostra = true
		this.criandoNovoTamanho = criandoNovoTamanho

		setTimeout(() => {
			this.form.resetValidation()
			this.campoDeDescricao.focus()
		})
	}

	esconder() {
		this.tamanhoDaEtiqueta = null
		this.mostra = false
	}

	get podeAlterarAcao() {
		return this.podeRealizarOperacao('alterar')
	}

	podeRealizarOperacao(operacao: TipoDeOperacao) {
		return UserLoginStore.temAutorizacao(montarOperacaoDeRecurso(operacao, 'tamanhos-de-etiqueta'))
	}

	gerarDataHora(data?: string | null, hora?: string | null): string {
		return moment(`${data} ${hora}`, 'YYYY-MM-DD HH:mm').toISOString(true)
	}

	async salvar(){
		if (!this.tamanhoDaEtiqueta) return
		if (!this.form.validate()) return
		try {
			if(!this.tamanhoDaEtiqueta.grupoEconomico){
				AlertModule.setError('Obrigatório informar grupo econômico')
			}
			this.salvando = true
			
			const tamanhoSalvo = !this.tamanhoDaEtiqueta.id
				? await this.etiquetaDePrecoService.createTamanhoDeEtiqueta(this.tamanhoDaEtiqueta)
				: await this.etiquetaDePrecoService.updatetamanhoDaEtiqueta(this.tamanhoDaEtiqueta.id, this.tamanhoDaEtiqueta)

			this.$emit('confirmado', tamanhoSalvo)
			this.mostra = false
			AlertModule.setSuccess('Tamanho de etiqueta salvo com sucesso')
		}catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
			this.$emit('sucesso')
		}
	}

}
